export default "__VITE_ASSET__ASAjmc4W__"